import { render } from "./DocumentsSection.vue?vue&type=template&id=3cd2571f&ts=true"
import script from "./DocumentsSection.vue?vue&type=script&lang=ts"
export * from "./DocumentsSection.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__